import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { Injectable, Scope } from '@tokamakjs/injection';
import { useHooksContainer } from '../hooks';
import { Reflector } from '../reflection';
export function HookService() {
  return function (Target) {
    Reflector.addHookServiceMetadata(Target);
    Injectable({
      scope: Scope.TRANSIENT
    })(Target);
    var proxy = new Proxy(Target, {
      construct: function construct(Target, args) {
        var inst = Reflector.createHooksContainer.apply(Reflector, [Target].concat(_toConsumableArray(args)));
        return useHooksContainer(inst);
      }
    });
    Reflector.copyMetadata(Target, proxy);
    return proxy;
  };
}

HookService.isHookService = function (Target) {
  return Reflector.getHookServiceMetadata(Target) != null;
};